import { PicklistController } from './picklist.controller';
import { PicklistProps } from './picklist.model';

export const Picklist = (props: PicklistProps) => {
  return <PicklistController {...props} />;
};
